export default __webpack_public_path__ + "static/media/reckoning.41cea338.png";